enum RequiredRecoveryEmailFlowStepEnum {
    RecoveryEmailStep,
    RecoveryEmailIsMandatoryStep,
    MandatoryEmailSecondRequestStep,
    VerifyRecoveryEmailStep
}

export { RequiredRecoveryEmailFlowStepEnum };
